const { defineMessages } = require('@edx/frontend-platform/i18n');

const messages = defineMessages({
  report: {
    id: 'essentials.ReportButton.reportButton',
    defaultMessage: 'Report',
    description: 'Report button label.',
  },
  formTitle: {
    id: 'essentials.ReportButton.formTitle',
    defaultMessage: 'Report Reason?',
    description: 'Form title.',
  },
  sexualContent: {
    id: 'essentials.ReportButton.sexualContent',
    defaultMessage: 'Sexual content',
    description: 'Sexual content option.',
  },
  graphicViolence: {
    id: 'essentials.ReportButton.graphicViolence',
    defaultMessage: 'Graphic violence',
    description: 'Graphic violence option.',
  },
  hatefulOrAbusiveContent: {
    id: 'essentials.ReportButton.hatefulOrAbusiveContent',
    defaultMessage: 'Hateful or abusive content',
    description: 'Hateful or abusive content option.',
  },
  copycatOrImpersonation: {
    id: 'essentials.ReportButton.copycatOrImpersonation',
    defaultMessage: 'Copycat or impersonation',
    description: 'Copycat or impersonation option.',
  },
  otherObjection: {
    id: 'essentials.ReportButton.otherObjection',
    defaultMessage: 'Other objection',
    description: 'Other objection option.',
  },
  save: {
    id: 'essentials.ReportButton.saveButton',
    defaultMessage: 'Save',
    description: 'Save button label',
  },
  close: {
    id: 'essentials.ReportButton.closeButton',
    defaultMessage: 'Close',
    description: 'Close button label.',
  },
  successMessage: {
    id: 'essentials.ReportButton.successMessage',
    defaultMessage: 'The report reason was uploaded successfully.',
    description: 'Message after saving report.',
  },
  errorMessage: {
    id: 'essentials.ReportButton.errorMessage',
    defaultMessage: 'There was an error with your request, please try again later.',
    description: 'Message that is shown after a saving error.',
  },
  savedMessage: {
    id: 'essentials.ReportButton.savedMessage',
    defaultMessage: 'Your report has been already saved.',
    description: 'Message that is shown when the user already saved a report.',
  },
});

export default messages;
